import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, eur } from './pilotageApi';

const ETAT_BADGE = {
  demande: 'bg-n', devis_envoye: 'bg-a', devis_accepte: 'bg-b', acompte_paye: 'bg-g',
  contrat_signe: 'bg-g', a_preparer: 'bg-a', pret: 'bg-b', livre: 'bg-b',
  a_recuperer: 'bg-a', retourne: 'bg-n', solde: 'bg-g', clos: 'bg-n', refuse: 'bg-r', annule: 'bg-r',
};

export default function Dossiers() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => { api.liste().then(setData).catch((e) => setErr(e.message)); }, []);

  if (err) return <div className="wrap"><div className="nt ba">{err}</div></div>;
  if (!data) return <div className="load" data-testid="dossiers-loading">Chargement…</div>;

  return (
    <>
      <div className="top">
        <h1>Dossiers</h1>
        <span className="ctx mono">{data.total} dossier{data.total > 1 ? 's' : ''}</span>
        <div className="sp" />
        <button className="btn btn-p" data-testid="btn-nouveau-dossier" onClick={() => nav('/admin/devis')}>+ Nouveau dossier</button>
      </div>
      <div className="wrap">
        <div className="bk" data-testid="bloc-dossiers">
          {data.dossiers.length === 0
            ? <div className="empty">Aucun dossier. Créez-en un depuis le bouton en haut.</div>
            : data.dossiers.map((r) => (
              <div className="rw" key={r.id} data-testid={`dossier-${r.id}`} style={{ cursor: 'pointer' }} onClick={() => nav(`/pilotage/dossier/${r.id}`)}>
                <div className="gw">
                  <div className="t">{r.client_nom} <span className="mono" style={{ color: 'var(--t3)', fontWeight: 500 }}>· {r.numero}</span></div>
                  <div className="m">{r.date_livraison || 'Date à définir'} · {r.nb_articles} article(s)</div>
                </div>
                <span className={`bg ${ETAT_BADGE[r.etat] || 'bg-n'}`}>{r.libelle}</span>
                <div className="am">{eur(r.total)}</div>
                <div className="ac"><button className="btn btn-s" data-testid={`open-${r.id}`} onClick={(e) => { e.stopPropagation(); nav(`/pilotage/dossier/${r.id}`); }}>Ouvrir</button></div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}
